<div class="modal-container">
  <div class="modal-header no-print">
    <h2 mat-dialog-title>
      <mat-icon>print</mat-icon>
      <span>Imprimir Lista</span>
    </h2>
    <button mat-icon-button (click)="fechar()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- CONTENT BODY (Matches .content-body in CSS) -->
  <div class="content-body modal-print-container">
    <!-- LOADING STATE -->
    @if (isLoading) {
    <div class="loading-container no-print">
      <app-loading-box width="100%" height="300px"></app-loading-box>
    </div>
    }

    <!-- TABLE CONTENT -->
    @if (relatorioSimples.length > 0) {
    <div [hidden]="isLoading">
      <!-- No separate header title inside content, redundant with modal title or minimal header -->
      <div class="table-responsive">
        <table mat-table [dataSource]="relatorioSimples">
          <!-- Nome Column -->
          <ng-container matColumnDef="nome">
            <th mat-header-cell *matHeaderCellDef style="width: 22%">Nome</th>
            <td mat-cell *matCellDef="let element">{{ element.nome }}</td>
          </ng-container>
          <!-- Fantasia Column -->
          <ng-container matColumnDef="fantasia">
            <th mat-header-cell *matHeaderCellDef style="width: 18%">Fantasia</th>
            <td mat-cell *matCellDef="let element">{{ element.nomeFantasia }}</td>
          </ng-container>
          <!-- Documento Column -->
          <ng-container matColumnDef="documento">
            <th mat-header-cell *matHeaderCellDef style="width: 15%">CPF/CNPJ</th>
            <td mat-cell *matCellDef="let element">{{ element.cpfCnpj | cpfCnpj }}</td>
          </ng-container>
          <!-- Cidade Column -->
          <ng-container matColumnDef="cidade">
            <th mat-header-cell *matHeaderCellDef style="width: 15%">Município</th>
            <td mat-cell *matCellDef="let element">
              {{ element.cidade }}
              @if (element.uf) {
              <span> - {{ element.uf }}</span>
              }
            </td>
          </ng-container>
          <!-- Contato Column -->
          <ng-container matColumnDef="contato">
            <th mat-header-cell *matHeaderCellDef style="width: 15%">Telefone / Celular</th>
            <td mat-cell *matCellDef="let element">
              @if (element.telefone) {
              <div>{{ element.telefone | foneMask }}</div>
              }
              @if (element.celular && element.celular !== element.telefone) {
              <div>{{ element.celular | foneMask }}</div>
              }
            </td>
          </ng-container>
          <!-- Email Column -->
          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef style="width: 15%">E-mail</th>
            <td mat-cell *matCellDef="let element">{{ element.email }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    </div>
    }

    <!-- EMPTY STATE -->
    @if (!isLoading && relatorioSimples.length === 0) {
    <div class="text-center p-4">
      <p>Nenhum registro encontrado para os filtros selecionados.</p>
    </div>
    }
  </div>

  <!-- FOOTER ACTIONS -->
  <div class="modal-footer no-print">
    <button mat-stroked-button class="btn-secondary" (click)="fechar()">Cancelar</button>
    @if (!isLoading && relatorioSimples.length > 0) {
    <button mat-flat-button class="btn-primary" (click)="imprimir()">
      <mat-icon>print</mat-icon> Imprimir
    </button>
    }
  </div>
</div>